export class InfoUser {
  login: String;
  password: String;
  name: String;
}
